import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import {
    isPushSupported,
    getPermissionStatus,
    enablePush,
    disablePush
} from '../services/pushService';

const RED = '#B22222';
const DARK_RED = '#8B0000';
const GOLD = '#FFD700';

/**
 * ============================================================
 * NOTIFICATION ON/OFF
 * ============================================================
 *
 * ⚠️ BROWSER KA POPUP APNE AAP NAHI MAANGTE.
 *
 * Page khulte hi permission maangna sabse badi galti hai. Log
 * bina padhe "Block" daba dete hain - aur uske baad browser
 * DOBARA popup dikhata hi nahi. Wo banda hamesha ke liye
 * notifications se bahar ho jaata hai, aur usse theek karne ke
 * liye use browser settings mein jaana padta hai (jo koi nahi
 * karta).
 *
 * Isliye pehle apna card dikhate hain jisme SAAF likha hai ki
 * notification kis kaam ki hai. Banda samajh ke button dabaye,
 * tabhi browser ka popup aata hai.
 *
 * ⚠️ POOJARI KE LIYE YE SABSE ZAROORI FEATURE HAI:
 *
 * Poojari ko booking ka pata sirf email se chalta tha. 55-saal
 * ka purohit email nahi dekhta - booking 12 ghante mein
 * auto-cancel ho jaati thi. Isliye poojari wale card mein
 * "recommended" ka nishan hai.
 */
const NotificationToggle = ({ role }) => {

    const [status, setStatus] = useState('default');
    const [loading, setLoading] = useState(false);

    const isPoojari = role === 'POOJARI';

    useEffect(() => {
        setStatus(getPermissionStatus());
    }, []);

    const handleEnable = async () => {
        setLoading(true);
        const ok = await enablePush();
        setLoading(false);

        if (ok) {
            setStatus('granted');
            toast.success('Notifications enabled');
        } else {
            setStatus(getPermissionStatus());
            toast.error('Could not enable notifications');
        }
    };

    const handleDisable = async () => {
        setLoading(true);
        await disablePush();
        setLoading(false);
        setStatus('default');
        toast.info('Notifications turned off');
    };

        console.log('NotificationToggle render:', {
        supported: isPushSupported(),
        status: status,
        role: role
    });

    // ⚠️ Support hi nahi (jaise iPhone Safari ka normal tab) to
    // kuch mat dikhao. Button dikha ke fail hone dena bura
    // experience hai - banda samajhta hai app toota hua hai.
    if (!isPushSupported()) {
        return null;
    }

    // ⚠️ Block kiya hua hai - ab hum kuch nahi kar sakte.
    // Browser dobara popup nahi dikhayega. Sirf bata sakte hain
    // ki settings se on karna padega.
    if (status === 'denied') {
        return (
            <div className="p-3 mb-3"
                style={{
                    backgroundColor: '#FFF8E1',
                    border: `1px solid ${GOLD}`,
                    borderRadius: '12px'
                }}>
                <p className="mb-0" style={{ fontSize: '13px', color: '#666' }}>
                    🔕 Notifications are blocked. To turn them on, allow
                    notifications for this site in your browser settings.
                </p>
                                <p className="mb-0 mt-2"
                    style={{ fontSize: '11px', color: '#999' }}>
                    debug: state={status} | live={typeof Notification !== 'undefined'
                        ? Notification.permission : 'n/a'} | standalone={String(
                        window.matchMedia('(display-mode: standalone)').matches)}
                </p>
            </div>
        );
    }

    // ⚠️ Notification ON hai - kuch mat dikhao.
    if (status === 'granted') {
        return null;
    }

    // Abhi tak poocha nahi - card dikhao
    return (
        <div className="p-3 mb-3"
            style={{
                backgroundColor: 'white',
                border: `1px solid ${GOLD}`,
                borderRadius: '12px'
            }}>
            <p className="mb-1 fw-bold" style={{ color: DARK_RED, fontSize: '14px' }}>
                🔔 Turn on notifications
                {isPoojari && (
                    <span className="ms-2"
                        style={{
                            backgroundColor: GOLD,
                            color: DARK_RED,
                            fontSize: '10px',
                            padding: '2px 6px',
                            borderRadius: '6px'
                        }}>
                        Recommended
                    </span>
                )}
            </p>

            <p className="mb-3" style={{ color: '#666', fontSize: '12px' }}>
                {isPoojari
                    ? 'Get an alert on your phone as soon as a booking arrives. Bookings not accepted in time are cancelled automatically.'
                    : 'Know right away when a poojari accepts or updates your booking.'}
            </p>

            <button
                type="button"
                className="btn w-100 fw-bold py-2"
                style={{
                    backgroundColor: RED,
                    color: GOLD,
                    border: 'none',
                    borderRadius: '10px',
                    fontSize: '14px'
                }}
                onClick={handleEnable}
                disabled={loading}>
                {loading ? 'Please wait...' : 'Enable notifications'}
            </button>
        </div>
    );
};

export default NotificationToggle;